import { Link } from 'react-router-dom'
import '../styles/landing.css'

const plans = [
  {
    id: 'monthly',
    label: 'Mensual',
    price: 250,
    duration: '1 mes',
    icon: '📅',
    badge: 'Básico',
    badgeColor: '#6b7280',
    recommended: false,
    savings: null,
    features: [
      'Acceso web completo por 1 mes',
      'Simuladores EXANI-II ilimitados (168 reactivos)',
      'Material de estudio completo (áreas transversales + módulos)',
      'Audioteca Vortex completa',
      'Mapa de debilidades y métricas de admisión',
      'Flashcards con repetición espaciada',
      'Modo audio / Modo guardia',
      'Actualizaciones continuas',
    ],
  },
  {
    id: 'biannual',
    label: 'Bimestral',
    price: 450,
    duration: '2 meses',
    icon: '🗓️',
    badge: 'Popular',
    badgeColor: '#3b82f6',
    recommended: true,
    savings: 'Ahorra $50 vs mensual',
    features: [
      'Acceso web completo por 2 meses',
      'Simuladores EXANI-II ilimitados (168 reactivos)',
      'Material de estudio completo (áreas transversales + módulos)',
      'Audioteca Vortex completa',
      'Mapa de debilidades y métricas de admisión',
      'Flashcards con repetición espaciada',
      'Modo audio / Modo guardia',
      'Actualizaciones continuas',
    ],
  },
  {
    id: 'semiannual',
    label: 'Semestral',
    price: 1100,
    duration: '6 meses',
    icon: '📆',
    badge: 'Conveniente',
    badgeColor: '#8b5cf6',
    recommended: false,
    savings: 'Ahorra $400 vs mensual',
    features: [
      'Acceso web completo por 6 meses',
      'Simuladores EXANI-II ilimitados (168 reactivos)',
      'Material de estudio completo (áreas transversales + módulos)',
      'Audioteca Vortex completa',
      'Mapa de debilidades y métricas de admisión',
      'Flashcards con repetición espaciada',
      'Modo audio / Modo guardia',
      'Actualizaciones continuas',
    ],
  },
  {
    id: 'annual',
    label: 'Anual',
    price: 1900,
    duration: '12 meses',
    icon: '💎',
    badge: 'Mejor Valor',
    badgeColor: '#f59e0b',
    recommended: false,
    savings: 'Ahorra $1,100 vs mensual',
    features: [
      'Acceso web completo por 12 meses',
      'Simuladores EXANI-II ilimitados (168 reactivos)',
      'Material de estudio completo (áreas transversales + módulos)',
      'Audioteca Vortex completa',
      'Mapa de debilidades y métricas de admisión',
      'Flashcards con repetición espaciada',
      'Modo audio / Modo guardia',
      'Actualizaciones continuas',
    ],
  },
]

const includedFeatures = [
  { icon: '🎯', title: 'Simuladores Oficiales', desc: 'Exámenes EXANI-II de 168 reactivos con cronómetro oficial Ceneval y ponderación real' },
  { icon: '📚', title: 'Material de Estudio', desc: 'Áreas transversales (Comprensión Lectora, Redacción Indirecta, Pensamiento Matemático, Inglés) y módulos disciplinares' },
  { icon: '🎵', title: 'Audioteca Vortex', desc: 'Temario y resúmenes narrados en formato de audio para estudio en movimiento' },
  { icon: '📊', title: 'Mapa de Debilidades', desc: 'Diagnóstico visual por área con semáforo 🔴🟡🟢 para enfocar tu esfuerzo' },
  { icon: '📇', title: 'Flashcards Inteligentes', desc: 'Repetición espaciada y autoevaluación para fijar conceptos clave' },
  { icon: '🎧', title: 'Modo Audio / Guardia', desc: 'Estudio auditivo pasivo: pregunta → pausa de reflexión → respuesta' },
  { icon: '🧭', title: 'Métricas de Admisión', desc: 'Puntaje predictivo frente al estándar de ingreso y progreso diario' },
]

const faqs = [
  { q: '¿Qué diferencia hay entre la suscripción web y la app móvil?', a: 'Son suscripciones independientes. La suscripción web te da acceso a la versión de navegador (escritorio/móvil web) y no incluye la app nativa de Android/iOS, y viceversa.' },
  { q: '¿Cómo se activa mi suscripción tras el pago?', a: 'Al completar el pago seguro con Stripe, tu suscripción se activa automáticamente en tu cuenta y tendrás acceso inmediato al dashboard completo.' },
  { q: '¿Puedo cambiar de plan después de comprar?', a: 'Sí. Puedes actualizar tu plan en cualquier momento desde tu perfil. El cambio se prorratea según el tiempo restante.' },
  { q: '¿Hay política de reembolso?', a: 'Sí. Puedes solicitar reembolso escribiendo a vortexadmision@gmail.com dentro de los primeros 7 días de tu compra. Pasado ese plazo, el acceso permanece hasta el final del periodo pagado.' },
  { q: '¿La suscripción se renueva automáticamente?', a: 'Sí, las suscripciones se renuevan automáticamente al final de cada periodo. Puedes cancelar la renovación desde tu perfil en cualquier momento antes del siguiente cargo.' },
  { q: '¿Qué métodos de pago aceptan?', a: 'Procesamos los pagos de forma 100% segura a través de Stripe, aceptando tarjetas de crédito/débito (Visa, Mastercard, American Express) y otros métodos según tu país.' },
]

export default function SubscriptionPlans() {
  return (
    <section id="subscription-plans" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Planes de Suscripción Vortex EXANI-II</h2>
          <p className="section-subtitle">
            Elige el plan que mejor se adapte a tu tiempo de preparación. Todos los planes incluyen acceso completo a la plataforma web.
          </p>
        </div>

        {/* Planes Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 'var(--spacing-lg)',
          marginBottom: 'var(--spacing-3xl)',
          maxWidth: '100%',
        }}>
          {plans.map((plan) => (
            <article
              key={plan.id}
              style={{
                background: plan.recommended
                  ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.12) 0%, rgba(102, 126, 234, 0.12) 100%)'
                  : 'var(--bg-tertiary)',
                border: plan.recommended
                  ? '2px solid var(--accent)'
                  : '1px solid var(--border)',
                borderRadius: 'var(--radius-lg)',
                padding: 'var(--spacing-xl)',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease',
              }}
              onMouseEnter={(e) => {
                if (!plan.recommended) {
                  e.currentTarget.style.transform = 'translateY(-4px)'
                  e.currentTarget.style.boxShadow = 'var(--shadow-lg)'
                }
              }}
              onMouseLeave={(e) => {
                if (!plan.recommended) {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = 'none'
                }
              }}
            >
              {plan.recommended && (
                <div style={{
                  position: 'absolute',
                  top: '-12px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: 'var(--accent)',
                  color: 'var(--navy-deep)',
                  padding: '4px 16px',
                  borderRadius: '20px',
                  fontSize: '0.7rem',
                  fontWeight: '700',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  whiteSpace: 'nowrap',
                  boxShadow: '0 4px 12px rgba(197, 160, 89, 0.4)',
                }}>
                  ⭐ {plan.badge}
                </div>
              )}

              <div style={{
                display: 'inline-block',
                background: `${plan.badgeColor}22`,
                border: `1px solid ${plan.badgeColor}55`,
                color: plan.badgeColor,
                borderRadius: '12px',
                padding: '4px 12px',
                fontSize: '0.7rem',
                fontWeight: '600',
                marginBottom: 'var(--spacing-md)',
                alignSelf: 'flex-start',
              }}>
                {plan.badge}
              </div>

              <div style={{ fontSize: '3rem', marginBottom: 'var(--spacing-sm)', textAlign: 'center' }}>
                {plan.icon}
              </div>

              <h3 style={{
                color: 'var(--text-primary)',
                fontSize: '1.35rem',
                fontWeight: '800',
                margin: '0 0 var(--spacing-xs) 0',
                textAlign: 'center',
              }}>
                {plan.label}
              </h3>

              <div style={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'center',
                gap: '4px',
                marginBottom: 'var(--spacing-xs)',
              }}>
                <span style={{
                  fontSize: '2.5rem',
                  fontWeight: '800',
                  color: 'var(--text-primary)',
                }}>
                  ${plan.price.toLocaleString()}
                </span>
                <span style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}> MXN</span>
              </div>

              <p style={{
                color: 'var(--text-secondary)',
                fontSize: '0.85rem',
                margin: '0 0 var(--spacing-md) 0',
                textAlign: 'center',
              }}>
                {plan.duration}
              </p>

              {plan.savings && (
                <p style={{
                  color: '#10b981',
                  fontSize: '0.78rem',
                  fontWeight: '600',
                  margin: '0 0 var(--spacing-lg) 0',
                  textAlign: 'center',
                }}>
                  {plan.savings}
                </p>
              )}

              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 'var(--spacing-sm)',
              }}>
                {plan.features.map((feature, i) => (
                  <li key={i} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 'var(--spacing-sm)',
                    fontSize: '0.85rem',
                    color: 'var(--text-secondary)',
                    lineHeight: 1.5,
                  }}>
                    <span style={{
                      color: plan.recommended ? 'var(--accent)' : '#10b981',
                      flexShrink: 0,
                      marginTop: '2px',
                    }}>✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <Link
                to="/purchase-license"
                state={{ plan: plan.id }}
                style={{
                  display: 'block',
                  textAlign: 'center',
                  marginTop: 'var(--spacing-lg)',
                  padding: 'var(--spacing-md) var(--spacing-lg)',
                  borderRadius: 'var(--radius-md)',
                  background: plan.recommended
                    ? 'linear-gradient(135deg, var(--gold-light), var(--gold-matte) 45%, #a7803f)'
                    : 'linear-gradient(135deg, #6366f1 0%, #06b6d4 100%)',
                  color: plan.recommended ? 'var(--navy-deep)' : '#ffffff',
                  fontWeight: '700',
                  fontSize: '0.95rem',
                  textDecoration: 'none',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease',
                  boxShadow: plan.recommended
                    ? '0 0 22px rgba(197, 160, 89, 0.55), 0 18px 40px rgba(0, 0, 0, 0.5)'
                    : '0 8px 20px rgba(99, 102, 241, 0.3)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)'
                  e.currentTarget.style.boxShadow = plan.recommended
                    ? '0 0 34px rgba(197, 160, 89, 0.75), 0 22px 44px rgba(0, 0, 0, 0.55)'
                    : '0 12px 28px rgba(99, 102, 241, 0.5)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = plan.recommended
                    ? '0 0 22px rgba(197, 160, 89, 0.55), 0 18px 40px rgba(0, 0, 0, 0.5)'
                    : '0 8px 20px rgba(99, 102, 241, 0.3)'
                }}
              >
                Seleccionar {plan.label}
              </Link>
            </article>
          ))}
        </div>

        {/* Qué incluye */}
        <div className="howitworks-banner" style={{ marginBottom: 'var(--spacing-3xl)' }}>
          <h3 style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
            ¿Qué incluye tu suscripción?
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 'var(--spacing-lg)',
          }}>
            {includedFeatures.map((feature, i) => (
              <div key={i} style={{
                background: 'var(--bg-tertiary)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-lg)',
                padding: 'var(--spacing-lg)',
                textAlign: 'center',
                transition: 'transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease',
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)'
                  e.currentTarget.style.boxShadow = 'var(--shadow-lg)'
                  e.currentTarget.style.borderColor = 'var(--accent)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = 'none'
                  e.currentTarget.style.borderColor = 'var(--border)'
                }}
              >
                <div style={{ fontSize: '2.5rem', marginBottom: 'var(--spacing-md)' }}>
                  {feature.icon}
                </div>
                <h4 style={{
                  color: 'var(--text-primary)',
                  fontSize: '1.05rem',
                  fontWeight: '700',
                  margin: '0 0 var(--spacing-xs) 0',
                }}>
                  {feature.title}
                </h4>
                <p style={{
                  color: 'var(--text-secondary)',
                  fontSize: '0.85rem',
                  lineHeight: 1.6,
                  margin: 0,
                  textAlign: 'justify',
                  hyphens: 'auto',
                }}>
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Comparativa */}
        <div className="howitworks-banner" style={{ marginBottom: 'var(--spacing-3xl)', overflowX: 'auto' }}>
          <h3 style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
            📊 Comparativa de Planes
          </h3>
          <table style={{
            width: '100%',
            minWidth: '700px',
            borderCollapse: 'collapse',
            color: 'var(--text-primary)',
            background: 'var(--bg-tertiary)',
            borderRadius: 'var(--radius-lg)',
            overflow: 'hidden',
          }}>
<thead>
              <tr style={{ background: 'rgba(197, 160, 89, 0.15)' }}>
                <th style={{ padding: 'var(--spacing-md)', textAlign: 'left', fontWeight: '700' }}>Característica</th>
                <th style={{ padding: 'var(--spacing-md)', textAlign: 'center', fontWeight: '700' }}>Mensual</th>
                <th style={{ padding: 'var(--spacing-md)', textAlign: 'center', fontWeight: '700', color: 'var(--accent)' }}>Bimestral</th>
                <th style={{ padding: 'var(--spacing-md)', textAlign: 'center', fontWeight: '700' }}>Semestral</th>
                <th style={{ padding: 'var(--spacing-md)', textAlign: 'center', fontWeight: '700' }}>Anual</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Precio', '$250 MXN', '$450 MXN', '$1,100 MXN', '$1,900 MXN'],
                ['Acceso web completo', '✅', '✅', '✅', '✅'],
                ['Simuladores de examen (168 reactivos)', '✅', '✅', '✅', '✅'],
                ['Material de estudio completo', '✅', '✅', '✅', '✅'],
                ['Audioteca Vortex', '✅', '✅', '✅', '✅'],
                ['Mapa de debilidades', '✅', '✅', '✅', '✅'],
                ['Flashcards + Modo audio', '✅', '✅', '✅', '✅'],
                ['Métricas de admisión', '✅', '✅', '✅', '✅'],
              ].map((row, i) => (
                <tr key={i} style={{ borderBottom: '1px solid var(--border)' }}>
                  {row.map((cell, j) => (
                    <td key={j} style={{
                      padding: 'var(--spacing-sm) var(--spacing-md)',
                      textAlign: j === 0 ? 'left' : 'center',
                      color: j === 0 ? 'var(--text-primary)' : '#10b981',
                      fontWeight: j === 0 ? '500' : '600',
                      fontSize: '0.9rem',
                    }}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
<tr style={{ background: 'rgba(197, 160, 89, 0.05)' }}>
                <td style={{ padding: 'var(--spacing-md)', fontWeight: '700' }}>Ahorro vs Mensual</td>
                <td style={{ padding: 'var(--spacing-md)', textAlign: 'center', color: 'var(--text-muted)' }}>—</td>
                <td style={{ padding: 'var(--spacing-md)', textAlign: 'center', color: '#10b981', fontWeight: '700' }}>¡$50 MXN!</td>
                <td style={{ padding: 'var(--spacing-md)', textAlign: 'center', color: '#10b981', fontWeight: '700' }}>¡$400 MXN!</td>
                <td style={{ padding: 'var(--spacing-md)', textAlign: 'center', color: '#10b981', fontWeight: '700' }}>¡$1,100 MXN!</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* FAQ */}
        <div className="howitworks-banner">
          <h3 style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
            ❓ Preguntas Frecuentes
          </h3>
          <div style={{ display: 'grid', gap: 'var(--spacing-md)' }}>
            {faqs.map((faq, i) => (
              <details key={i} style={{
                background: 'var(--bg-tertiary)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-md)',
                padding: 'var(--spacing-lg)',
              }}>
                <summary style={{
                  cursor: 'pointer',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  outline: 'none',
                  listStyle: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--spacing-sm)',
                }}>
                  {faq.q}
                </summary>
                <p style={{
                  marginTop: 'var(--spacing-sm)',
                  color: 'var(--text-secondary)',
                  fontSize: '0.9rem',
                  lineHeight: 1.6,
                  textAlign: 'justify',
                  hyphens: 'auto',
                }}>
                  {faq.a}
                </p>
              </details>
            ))}
          </div>

          <div className="section-cta" style={{ marginTop: 'var(--spacing-2xl)' }}>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 'var(--spacing-lg)' }}>
              ¿Listo para comenzar tu preparación con acceso completo?
            </p>
            <Link to="/purchase-license" className="btn btn-primary" style={{ fontSize: '1.05rem', padding: 'var(--spacing-md) var(--spacing-xl)' }}>
              💎 Ver Planes y Comprar
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}